import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CardMarkerSmall from '../../../components/CockpitCards/CardMarkerSmall';
import VaccsActions2 from "./VaccsRecords/VaccsActions2";
import { useTheme } from "@mui/material";


export default function SectionVaccsCard2() {
  
const theme = useTheme();

return (
<>

{theme.palette.mode === "light" ? (

<CardMarkerSmall 
  
headline="VACCINATION CARDS"  

cardlines = {<>      

    <Grid container >              
                          
        <Grid item xs={8} sx={{display:'flex', alignItems:'flex-end' }} >   
          <Typography variant="body2" sx={{p:1}}> Vaccination cards are useful health records that contain information about vaccination dates and dosage. This information is helpful for doctors, parents and others. </Typography>
        </Grid>                                                  
        
        <Grid item xs={2} sx={{pl:2, display:'flex', alignItems:'center'}}> <VaccsActions2 />  </Grid> 
        
    </Grid>
        
  </>}   
 />    

) : (

  <CardMarkerSmall 
  
  headline="VACCINATION CARDS"  
  
  cardlines = {<>      
  
      <Grid container >              
                            
          <Grid item xs={8} sx={{display:'flex', alignItems:'flex-end' }} >   
            <Typography variant="body2" sx={{p:1}}> Vaccination cards are useful health records that contain information about vaccination dates and dosage. This information is helpful for doctors, parents and others. </Typography>
          </Grid>                                                  
          
          <Grid item xs={2} sx={{pl:2, display:'flex', alignItems:'center'}}> <VaccsActions2 />  </Grid> 
          
      </Grid>
          
    </>}   
   />    

)}

 </>
 )};
  